import React from 'react';
import {
  TextPlaceholder,
  BlockPlaceholder,
} from '../../../../ui-components/Placeholder/Placeholder';
import { Flex } from '../../../../ui-components/Flex/Flex';

export const SlidesLibraryPlaceholder = () => {
  return (
    <Flex direction="column" gap="32px 32px">
      {[1, 2].map((sectionPlaceholder) => {
        return (
          <Flex direction="column" gap={32} key={sectionPlaceholder}>
            <TextPlaceholder size="small" />
            {[1, 2, 3].map((placeholder) => {
              return (
                <Flex key={placeholder} justify="center" gap={32}>
                  <BlockPlaceholder size="medium" />
                  <BlockPlaceholder size="medium" />
                </Flex>
              );
            })}
          </Flex>
        );
      })}
    </Flex>
  );
};
